// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_b066d19","infoBox":"_dbe6d49","infoText":"_571ae33","arrowContainer":"_e086327","arrow":"_f3c71cb","active":"_f9ff27d"};